import { render, staticRenderFns } from "./search-template-custom.vue?vue&type=template&id=4f60cc3f&scoped=true&"
import script from "./search-template-custom.vue?vue&type=script&lang=js&"
export * from "./search-template-custom.vue?vue&type=script&lang=js&"
import style0 from "./search-template-custom.vue?vue&type=style&index=0&id=4f60cc3f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f60cc3f",
  null
  
)

export default component.exports